<template>
  <div class="testIndex">
    <el-row :gutter="10" v-if="totalCount" v-loading="loading">
      <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="12"
          v-for="(item,index) in data"
          :key="index"
          style="margin-top: 10px;"
      >
        <el-card shadow="always" :class="screenWidth>768 ?'pc_wrapper':'mobile_wrapper'">
          <div class="testIndex-content">
            <div class="testIndex-left">
              <!--<el-image style="width: 150px; height: 150px" :src="imgPath"'+'"item.file_path"></el-image>-->
              <el-image style="width: 150px; height: 150px" :src="getImgUrl(item.file_path)"></el-image>
            </div>
            <div class="testIndex_right">
              <ul class="card_content_ul">
                <li>
                  <h4 style="padding-left:20px;">{{ item.test_class_title }}</h4>
                </li>
                <li class="card_content_li">
                  <span
                      class="icon common_backgroundImg"
                      :style="'background-image:url(' + iconList[0]  + ')'"
                  ></span>
                  测试机构：
                  <span>{{ item.mechanism_fullName }}</span>
                </li>
                <li class="card_content_li">
                  <span
                      class="icon common_backgroundImg"
                      :style="'background-image:url(' + iconList[1]  + ')'"
                  ></span>
                  报名时间：
                  <span
                      class="size"
                  >{{
                      item.registration_start_time|dateformat('YYYY-MM-DD HH:mm')
                    }} 至 {{ item.registration_end_time|dateformat('YYYY-MM-DD HH:mm') }}</span>
                </li>
                <li class="card_content_li">
                  <span
                      class="icon common_backgroundImg"
                      :style="'background-image:url(' + iconList[1]  + ')'"
                  ></span>
                  测试时间：
                  <span
                      class="size"
                  >{{
                      item.test_start_time|dateformat('YYYY-MM-DD HH:mm')
                    }} 至 {{ item.test_end_time|dateformat('YYYY-MM-DD HH:mm') }}</span>
                </li>
                <li class="card_content_li">
                  <span
                      class="icon common_backgroundImg"
                      :style="'background-image:url(' + iconList[2]  + ')'"
                  ></span>
                  测试地址：
                  {{
                    item.provinceName == item.cityName ? item.provinceName : item.provinceName + item.cityName
                  }}{{ item.districtName }}{{ item.detailed_address }}
                </li>
                <li class="card_content_li">
                  <span
                      class="icon common_backgroundImg"
                      :style="'background-image:url(' + iconList[3]  + ')'"
                  ></span>
                  测试等级：
                  <span
                      v-for="(item1,index) in item.grade"
                      :key="index"
                      style="font-size:15px"
                      class="grade_span"
                  >
                    {{ item1.grade }}
                    <label>\</label>
                  </span>
                </li>
                <!-- <span class="card_details">
                  <el-button size="mini">详 情</el-button>
                </span>-->
              </ul>
            </div>
          </div>
          <div style="text-align:center;margin:5px 0px;">
            <!-- <router-link :to="{path:'/test/signUp',query:{data:item,surePay: false}}"> -->
            <!-- <el-button type="danger" style="width:150px;height:40px" @click="signUp(item)">报 名</el-button> -->
            <el-button v-if="item.isStop" disabled type="info" style="width:150px;height:40px">报 名</el-button>
            <el-button v-else type="danger" style="width:150px;height:40px" @click="signUp(item)">报 名</el-button>
            <!-- </router-link> -->
            <!-- :disabled="!nowInDateBetwen(getDate(new Date(item.registration_start_time)),getDate(new Date(item.registration_end_time)),getDate(new Date())) || item.grade_submission_status != 0 || levels.length==0" -->
          </div>
        </el-card>
      </el-col>
    </el-row>

    <no-data v-else/>

    <div class="pagination">
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="paging.limit"
          :total="totalCount"
          v-if="totalCount>10"
      ></el-pagination>
    </div>

    <el-dialog title="等级选择" :visible.sync="chooseGradeVisible" :width="screenWidth>768?'40%':'90%'" center>
      <div style="margin-top: 20px;text-align:center">
        <el-radio-group v-model="bmInfo.key" v-for="(item,index) in gradeList" :key="index">
          <el-radio
              :label="item.key"
              border
              text-color
              style="margin:10px 10px 0px 0px;"
          >{{ item.value }}
          </el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseGradeVisible = false">取 消</el-button>
        <el-button type="primary" @click="chooseGradeSure">确 定</el-button>
      </span>
    </el-dialog>

    <role-permissions
        :dialogVisible="dialogVisible"
        @changeDialogVisible="changeDialogVisible"
        roleName="运动员"
    />
  </div>
</template>

<script>
import {GetExaminerClassList} from "@/api/admin/common.js";
import {GetTestGradeList} from "@/api/admin/athletes.js";
import {mapGetters} from "vuex";
import rolePermissions from "@/views/admin/components/rolePermissions.vue";
import noData from "@/views/admin/components/noData.vue";

export default {
  components: {
    rolePermissions,
    noData
  },
  data() {
    return {
      iconList: [
        "/image/index/csjg.png",
        "/image/index/icon_time.png",
        "/image/index/icon_place.png",
        "/image/index/icon_level.png"
      ],
      data: [],
      val: {},
      totalCount: 0,
      paging: {
        limit: 10,
        page: 1
      },
      test: {},
      loading: false,
      dialogVisible: false,
      imgPath: window.apiObj.apiUrl,
      chooseGradeVisible: false,
      gradeList: [],
      bmInfo: {}
    };
  },
  computed: {
    ...mapGetters(["userRole", "levels", 'screenWidth'])
  },
  created() {
    this.getList();
  },
  mounted() {
    this.searchBus.$on("SearchData2", msg => {
      this.searchALLdata(msg);
    });
  },
  methods: {
    //图片路径拼接
    getImgUrl(file_path) {
      var url = this.imgPath + file_path;
      return url;
    },
    //报名角色判断
    signUp(item) {
      this.bmInfo = item;
      if (this.userRole == 1) {
        GetTestGradeList({id: item.id}).then(data => {

          const list = data.data.result;
          this.gradeList = list.items;
          if (this.gradeList.length == 1) {
            this.$router.push({
              path: "/test/signUp",
              query: {id: item.id, key: this.gradeList[0].key}
            });
          } else if (this.gradeList.length == 0) {
            this.$message({
              message: "您未取得测试等级资格",
              type: "warning"
            });
          } else {
            this.chooseGradeVisible = true;
          }
        });
      } else {
        this.dialogVisible = true;
      }
    },
    changeDialogVisible(val) {
      this.dialogVisible = val;
    },
    chooseGradeSure() {
      if (this.bmInfo.key) {
        this.gradeList.forEach(i => {
          if (i.key == this.bmInfo.key) {
            Object.assign(this.bmInfo, i);
          }
        });
        this.$router.push({
          path: "/test/signUp",
          query: {id: this.bmInfo.id, key: this.bmInfo.key}
        });
        this.chooseGradeVisible = false;
      } else {
        this.$message({
          message: "请选择测试等级",
          type: "warning"
        });
      }
    },
    getList() {
      // 测试班列表
      this.loading = true;
      GetExaminerClassList(Object.assign(this.paging))
          .then(data => {
            var list = data.data.result;
            if (list) {
              this.data = list.items;

              this.totalCount = list.totalCount;
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
    },
    // 分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      GetExaminerClassList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    },
    searchALLdata(msg) {
      GetExaminerClassList(Object.assign(this.paging, msg)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount;
        }
      });
    }
  },
  beforeDestroy() {
    this.searchBus.$off("SearchData2");
  }
};
</script>

<style lang="less" scoped>
.testIndex {
  .el-card__body {
    padding: 15px;
  }

  .testIndex-content {
    width: 100%;
    display: flex;

    .testIndex_left {
      width: 100%;
    }

    .testIndex_right {
      width: 100%;
      padding: 0px 10px;

      .card_content_ul {
        position: relative;

        .card_content_li {
          margin: 5px 0px;

          .icon {
            display: inline-block;
            width: 20px;
            height: 20px;
            position: relative;
            top: 4px;
          }

          .size {
            font-size: 14px;
          }

          .grade_span:last-child label {
            display: none;
          }
        }

        .card_details {
          position: absolute;
          right: 0px;
          top: 0px;
        }

        .el-button:focus,
        .el-button:hover {
          background: #fddfe5;
          border-color: #fddfe5;
          color: #fff;
        }
      }
    }
  }

  .pagination {
    margin: 50px 0px;
    text-align: center;
  }
}

@media screen and (max-width: 1024px) {
  .testIndex {
    .testIndex-content {
      .testIndex_right {
        .card_content_ul {
          .card_content_li {
            .size {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .testIndex {
    .testIndex-left {
      .el-image {
        display: none;
      }
    }

    .el-button {
      width: 30% !important;
      height: 33px !important;
      padding: 0;
    }
  }
}

.pc_wrapper {
  height: 280px;
}
</style>
